import { render } from "./Dashboard.vue?vue&type=template&id=58260a45&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=58260a45&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-58260a45"

export default script